import apiClient from '@api/apiClient';

const authByEmail = async (email, password) => {
  try {
    const jsonData = {
      email: email,
      password: password,
    };
    const response = await apiClient.post('auth/email_login', jsonData);
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {
      access_token: '',
      refresh_token: '',
    };
  } catch (e) {
    console.log(e);
    return {
      access_token: '',
      refresh_token: '',
    };
  }
};

const refreshToken = async () => {
  try {
    const refresh_token = localStorage.getItem('refreshToken');
    const response = await apiClient.post(
      `auth/refresh_token`,
      {},
      {
        _isRefreshRequest: true,
        skipErrorHandler: true,
        headers: {
          Authorization: `Bearer ${refresh_token}`,
        },
      },
    );
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {
      access_token: '',
      refresh_token: '',
    };
  } catch (e) {
    console.log('Token refresh failed:', e);
    throw e;
  }
};

const recoveryPassword = async email => {
  try {
    const jsonData = {
      email: email,
    };
    const response = await apiClient.post('auth/restore_email', jsonData);
    const {data} = response || {};
    if (data) {
      return data;
    }
    return '';
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const recoveryPasswordSet = async (email, code, password) => {
  try {
    const jsonData = {
      email,
      code,
      password,
    };
    const response = await apiClient.post('auth/restore_email_code', jsonData);
    const {data} = response || {};
    if (data) {
      return data;
    }
    return '';
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const getUsers = async () => {
  try {
    const response = await apiClient.get('users', {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    if (data) {
      return data;
    }
    return [];
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const inviteUser = async (email, username, role_id) => {
  try {
    const jsonData = {
      email: email,
      username: username,
      role_id: role_id,
    };
    const response = await apiClient.post('users/invite_user', jsonData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const acceptInvite = async (email, code, password) => {
  try {
    const jsonData = {
      email: email,
      code: code,
      password: password,
    };
    const response = await apiClient.post('users/invite_user_code', jsonData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const sendReminder = async emails => {
  try {
    const jsonData = {
      users_emails: emails,
    };
    const response = await apiClient.post('users/refresh_invite', jsonData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const updateUser = async (id, email, username, role_id) => {
  try {
    const jsonData = {
      email: email,
      username: username,
      role_id: role_id,
    };
    const response = await apiClient.patch(`users/${id}`, jsonData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const deleteUsers = async users_ids => {
  try {
    let params = new URLSearchParams();
    users_ids.forEach(id => params.append('users_ids', id));
    const response = await apiClient.delete('users', {
      params: params,
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

export const userAPI = {
  authByEmail,
  refreshToken,
  recoveryPassword,
  recoveryPasswordSet,
  getUsers,
  inviteUser,
  acceptInvite,
  sendReminder,
  updateUser,
  deleteUsers,
};
